// extracted by mini-css-extract-plugin
module.exports = {"container":"purchase-card_container__m9ku1","item":"purchase-card_item__I7JxI","item-icon":"purchase-card_item-icon__C_qsc","item-title":"purchase-card_item-title__u1_mL"};